export enum EasingType {
    Linear,
    EaseIn,
    EaseOut,
    EaseInOut
}

export class AccelerationCurve {
    constructor(public easing: EasingType) {
    }

    getValue(ratio: number): number {
        switch (this.easing) {
            case EasingType.Linear:
                return this.linearTween(ratio, 0, 1, 1);
            case EasingType.EaseIn:
                return this.easeIn(ratio, 0, 1, 1);
            case EasingType.EaseOut:
                return this.easeOut(ratio, 0, 1, 1);
            case EasingType.EaseInOut:
                return this.easeInOut(ratio, 0, 1, 1);
        }
        return ratio;
    }

    linearTween(t, b, c, d): number {
        return c * t / d + b;
    }

    easeIn(t, b, c, d): number {
        t /= d;
        return c * t * t * t + b;
    }

    easeOut(t, b, c, d): number {
        t /= d;
        t--;
        return c * ( t * t * t + 1) + b;
    }

    easeInOut(t, b, c, d): number {
        t /= d / 2;
        if (t < 1) {
            return c / 2 * t * t * t + b;
        }
        t -= 2;
        return c / 2 * ( t * t * t + 2) + b;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/accelerationCurve.ts